import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import Frame from '../chrome/Frame';
import Text from '../chrome/Text';

const baseStyles = ({ theme }) => css`
  margin-top: ${theme.spacings.atom};
`;

const StyledText = styled(Text)(baseStyles);

const CircleBullet = ({ text }) => (
  <Frame isSolid isActive>
    <StyledText as='span' size='peta' bold noMargin>
      {text}
    </StyledText>
  </Frame>
);

CircleBullet.propTypes = {
  text: PropTypes.string,
};

CircleBullet.defaultProps = {
  text: '1',
};

export default CircleBullet;
